import { AxiosGlobalFilters, AxiosReportLas } from '../config';
import qs from 'qs';

// Tipagens de parâmetros
interface GetActivitiesPlansParams {
  companyId: number;
  unitId?: number;
  systemIds?: number[];
  search?: string;
  unidadeIds?: number[];
  grupoUnidadeIds?: number[];
  subGrupoUnidadeIds?: number[];
  estadoIds?: number[];
  cidadeIds?: number[];
  fornecedorIds?: number[];
}

interface GetCompanyDepartmentsParams {
  companyId: number;
  unidadeIds?: number[];
  grupoUnidadeIds?: number[];
  subGrupoUnidadeIds?: number[];
  estadoIds?: number[];
  cidadeIds?: number[];
  fornecedorIds?: number[];
}

interface GetUsersParams {
  companyId: number;
  unidadeId?: number[];
  fornecedores?: number[];
  search?: string;
  usuarioId?: number;
  tipoUsuario?: 1 | 2 | 3 | 4;
  grupoUnidadeId?: number[];
  subGrupoUnidadeId?: number[];
  estadoId?: number[];
  cidadeId?: number[];
  fornecedorId?: number[];
}

interface GetMaintenanceUnitsParams {
  companyId: number;
  unitId?: number;
  usuarioTipo?: 1 | 2 | 3 | 4;
  grupoUnidadeIds?: number[];
  subGrupoUnidadeIds?: number[];
  estadoId?: number;
  cidadeId?: number;
  codigo?: string;
  grupoUnidadeId?: number;
  subGrupoUnidadeId?: number;
  search?: string;
  fornecedorId?: number;
}

interface GetAreaGroupsParams {
  companyId: number;
  unidadeId?: number[];
  search?: string;
  PageIndex?: number;
  PageSize?: number;
  usuarioId?: number;
  tipoUsuario?: 1 | 2 | 3 | 4;
  grupoUnidadeId?: number[];
  subGrupoUnidadeId?: number[];
  estadoId?: number[];
  cidadeId?: number[];
  fornecedorId?: number[];
}

interface GetAreaSubgroupsParams {
  companyId: number;
  unidadeId?: number[];
  grupoAreaId?: string[];
  fornecedorId?: number[];
  search?: string;
  PageIndex?: number;
  PageSize?: number;
  usuarioId?: number;
  tipoUsuario?: 1 | 2 | 3 | 4;
  grupoUnidadeId?: number[];
  subGrupoUnidadeId?: number[];
  estadoId?: number[];
  cidadeId?: number[];
}

interface GetAreasParams {
  companyId: number;
  siteId?: number[];
  fornecedoresIds?: number[];
  grupoAreaId?: string[];
  subGrupoAreaId?: string[];
  search?: string;
  pageIndex?: number;
  pageSize?: number;
  areaId?: number[];
  planoAtividadesId?: number[];
}

interface GetEquipmentTypesParams {
  companyId: number;
  unitId: number;
}

interface GetEquipmentsParams {
  companyId: number;
  siteId?: number[];
  fornecedoresIds?: number[];
  sistemaId?: number;
  tipoEquipamentoId?: number;
  grupoAreaId?: number[];
  subGrupoAreaId?: number[];
  equipamentoId?: number[];
  areaId?: string[];
  grupoEquipamentoId?: string[];
  planoAtividadeId?: number[];
  search?: string;
  pageIndex?: number;
  pageSize?: number;
  fornecedorId?: number;
}

interface GetAgendaTasksParams {
  SelectedDate: string;
  Baixadas?: boolean;
  DiasAdicionais?: number;
  GrupoUnidadeId?: number;
  SubGrupoUnidadeId?: number;
  EstadoId?: number;
  CidadeId?: number;
  FornecedorId?: number;
  EquipamentoId?: number | number[];
  TipoEquipamentoId?: number | number[];
  SistemaEmpresaId?: number;
  SetorId?: number | number[];
  ExecutorId?: number | number[];
  GrupoAreaId?: number | number[];
  SubGrupoAreaId?: number | number[];
  AreaId?: number | number[];
  PlanoAtividadeId?: number | number[];
  AplicacaoPlanoAtividadeId?: number;
  PageIndex?: number;
  PageSize?: number;
  EmpresaId?: number;
  SiteId?: number[];
  TarefasIds?: number[];
}

interface ReagendarTarefasParams {
  usuarioId: number;
  tarefasIds: number[];
  novaDataHora: string;
}

interface GetAgendaTarefasParams {
  aplicacaoPlanoAtividadeId: number;
  data: string;
  status: 0 | 1;
  usuarioId?: number;
  empresaId?: number;
  unidadeId?: number;
}

// Tipagens de retorno

export interface AgendaTarefaExecutor {
  executorId: number;
  tempo: number;
  nome: string;
  telefone: string;
  fotoPath: string | null;
}

export interface DeleteAgendaTarefasParams {
  tarefasIds: number[];
  usuarioId: number;
  empresaId: number;
  unidadeId?: number;
}

export interface RestaurarTarefasParams {
  tarefasIds: number[];
  usuarioId: number;
  empresaId: number;
  unidadeId?: number;
  motivoReprovacao?: string;
  excluirFotosAssinaturas: boolean;
}

export interface AlterarAgendamentoItem {
  tarefa: number;
  dataPrevista: string;
  tempo: number;
  executores: number[];
}

export interface AlterarAgendamentoParams {
  usuarioId: number;
  empresaId: number;
  unidadeId?: number;
  itens: AlterarAgendamentoItem[];
}

export interface AlterarAgendamentoAplicacaoItem {
  tarefa: number;
  dataReferencia: string;
  executores: number[];
}

export interface AlterarAgendamentoAplicacaoParams {
  usuarioId: number;
  empresaId: number;
  unidadeId?: number;
  itens: AlterarAgendamentoAplicacaoItem[];
}

export interface AgendaTarefa {
  numero: number;
  descricao: string;
  dataPrevista: string;
  dataRealizada: string | null;
  tempoPrevisto: number;
  tempoRealizado: number;
  status: number;
  executores: AgendaTarefaExecutor[];
}

export interface AgendaTarefasAplicacao {
  numero: number;
  equipamentoNome: string | null;
  areaNome: string | null;
  unidadeNome: string;
}

export interface AgendaTarefasResponse {
  aplicacao: AgendaTarefasAplicacao;
  tarefas: AgendaTarefa[];
}

export interface ActivityPlan {
  planoId: number;
  nome: string;
}

export interface Department {
  setor: number;
  empresa: number;
  site: number | null;
  nome: string;
  status: number;
}

export interface User {
  usuario: number;
  nome: string;
  email: string | null;
  senha: string | null;
  inativo: boolean;
  superUsuario: boolean | null;
  login: string | null;
  usuarioDesignado: boolean | null;
  filtrosDefault: boolean;
  filtrosAlteracaoDefault: boolean;
  filtrosTodosTiposAnomalias: boolean;
  tipo: number;
  cargo: number | null;
  setor: number | null;
  assinaturaPath: string | null;
  celular: string | null;
  dataCadastro: string | null;
  acessoTodasAreas: boolean;
  tipoNome: string;
  image: string | null;
  emailValido: boolean;
}

export interface MaintenanceUnit {
  site: number;
  empresa: number;
  nome: string;
  codigo: string | null;
  endereco: string | null;
  grupoSite: number | null;
  statusSite: number;
  herdarPrioridadesAnomaliasDaEmpresa: boolean;
  habilitarBaixaAtividadeQRCode: boolean | null;
  habilitarBaixaAnomaliaQRCode: boolean | null;
  qrCode: string | null;
  logomarcaPath: string | null;
  quantidadeAreas: number;
  quantidadeEquipamentos: number;
  empresaObj: unknown | null;
}

export interface AreaGroup {
  grupoArea: number;
  gid: string;
  unidadeNome: string;
  nome: string;
}

export interface AreaSubgroup {
  gid: string;
  subGrupoArea: number;
  empresa: number;
  site: number;
  nome: string;
  status: number;
  grupoArea: number;
  insClidMob: string | null;
  insCliRecIdMob: number | null;
  insSincronizado: boolean | null;
  updClidMob: string | null;
  grupoAreaGID: string;
}

export interface EmpresaObj {
  empresa: number;
  nome: string;
  nomeFantasia: string;
  nomeLeankeep: string;
  status: number;
  tipo: number;
  habilitarAprovacaoCorrecao: boolean;
  empresaCliente: number;
  habilitarAvaliacaoCorrecao: boolean;
  habilitarBaixaAtividadeQRCode: boolean;
  habilitarBaixaAnomaliaQRCode: boolean;
  habilitarModuloAuditorias: boolean;
  habilitarModuloAlmoxarifados: boolean;
  assinaturaBaixaAnomaliaMobile: boolean;
  assinaturaBaixaTarefaMobile: boolean;
  habilitarIndisponibilidade: boolean;
  habilitarModuloGeolocalizacao: boolean;
  habilitarBloqueioCorrecoesNaoExecutor: boolean;
  notificacoesAdminOcorrencia: boolean;
  notificacaoAdminCorrececao: boolean;
  notificacaoOperacionalOcorrencia: number;
  notificacaoOperacionalCorrecao: number;
  logomarcaPath: string | null;
  habilitarQrCodePublico: boolean;
  tipoNome: string;
}

export interface SiteObj {
  site: number;
  empresa: number;
  nome: string;
  codigo: string | null;
  endereco: string | null;
  grupoSite: number | null;
  statusSite: number;
  herdarPrioridadesAnomaliasDaEmpresa: boolean;
  habilitarBaixaAtividadeQRCode: boolean | null;
  habilitarBaixaAnomaliaQRCode: boolean | null;
  qrCode: string | null;
  logomarcaPath: string | null;
  quantidadeAreas: number;
  quantidadeEquipamentos: number;
  empresaObj: EmpresaObj | null;
}

export interface GrupoAreaObj {
  gid: string;
  grupoArea: number;
  site: number;
  agrupamento: string;
  empresa: number;
  statusGrupoArea: number;
  insClidMob: string | null;
  insCliRecIdMob: number | null;
  insSincronizado: boolean | null;
}

export interface SubGrupoAreaObj {
  gid: string;
  subGrupoArea: number;
  empresa: number;
  site: number;
  nome: string;
  status: number;
  grupoArea: number;
  insClidMob: string | null;
  insCliRecIdMob: number | null;
  insSincronizado: boolean | null;
  updClidMob: string | null;
  grupoAreaGID: string;
}

export interface Area {
  gid: string;
  area: number;
  site: number;
  nome: string;
  localizacao: string | null;
  grupoArea: number;
  inativo: boolean;
  empresa: number;
  descricao: string | null;
  identificacaoAmbiente: string | null;
  tipoAtividade: string | null;
  areaClimatizada: string | null;
  cargaTermica: string | null;
  ocupantesFixos: string | null;
  ocupantesFlutuantes: string | null;
  pmoc: boolean;
  sistema: number | null;
  unidadeCargaTermica: string | null;
  espacoOcupado: number | null;
  subGrupoArea: number | null;
  fornecedor: number | null;
  codigoLocalizacao: string | null;
  insClidMob: string | null;
  insCliRecIdMob: number | null;
  insSincronizado: boolean;
  updClidMob: string | null;
  latitudeLongitude: string | null;
  grupoAreaGID: string | null;
  subGrupoAreaGID: string | null;
  codigoGLN: string | null;
  fotoPath: string | null;
  nomeFormatted: string | null;
  quantidadeEquipamentos: number;
  siteObj: SiteObj | null;
  grupoAreaObj: GrupoAreaObj | null;
  subGrupoAreaObj: SubGrupoAreaObj | null;
}

export interface EquipmentType {
  linhaProdutoEmpresa: number;
  linhaProduto: number;
  empresa: number;
  nome: string;
  codigo: string;
  inativo: boolean;
}

export interface Equipment {
  equipamento: number;
  gid: string;
  unidadeId: number;
  unidadeNome: string;
  nome: string;
  area: number;
  areaGid: string;
  areaNome: string;
  grupoAreaId: number;
  subgrupoAreaId: number;
  tag: string | null;
  foto: string | null;
  sistemaEmpresa: number;
  sistemaEmpresaNome: string;
}

export interface AgendaTaskExecutor {
  executor: number;
  nome: string;
  fotoPath: string | null;
  tempo: number;
}

export interface AgendaTask {
  primeiraDataHora: string;
  siteNome: string;
  planoAtividade: number;
  planoAtividadeNome: string | null;
  aplicacaoPlanoAtividade: number;
  grupoAreaNome: string | null;
  subGrupoAreaNome: string | null;
  areaNome: string | null;
  equipNome: string | null;
  realizada: boolean;
  qtdAtividades: number;
  tempoTotal: number;
  status: number;
  tarefas: number[];
  executoresTotal: number;
  executoresTempoTotal: number;
  atrasada: boolean;
  executores: AgendaTaskExecutor[];
}

const AgendaService = {
  getActivitiesPlans: ({
    companyId,
    unitId,
    systemIds,
    search,
    unidadeIds,
    grupoUnidadeIds,
    subGrupoUnidadeIds,
    estadoIds,
    cidadeIds,
    fornecedorIds,
  }: GetActivitiesPlansParams) => {
    const params: Record<string, number | number[] | string> = {
      EmpresaId: companyId,
    };
    const unidadeIdArray = unidadeIds?.length ? unidadeIds : unitId !== undefined ? [unitId] : undefined;
    if (unidadeIdArray?.length) params.UnidadeId = unidadeIdArray;
    if (systemIds?.length) params.SistemasIds = systemIds;
    if (search) params.Search = search;
    if (grupoUnidadeIds?.length) params.GrupoUnidadeId = grupoUnidadeIds;
    if (subGrupoUnidadeIds?.length) params.SubGrupoUnidadeId = subGrupoUnidadeIds;
    if (estadoIds?.length) params.EstadoId = estadoIds;
    if (cidadeIds?.length) params.CidadeId = cidadeIds;
    if (fornecedorIds?.length) params.FornecedorId = fornecedorIds;

    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/planosatividades/ativos`,
      params,
      paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }),
    });
  },

  getCompanyDepartments: ({
    companyId,
    unidadeIds,
    grupoUnidadeIds,
    subGrupoUnidadeIds,
    estadoIds,
    cidadeIds,
    fornecedorIds,
  }: GetCompanyDepartmentsParams) => {
    const params: Record<string, number | number[]> = {};
    if (unidadeIds?.length) params.UnidadeId = unidadeIds;
    if (grupoUnidadeIds?.length) params.GrupoUnidadeId = grupoUnidadeIds;
    if (subGrupoUnidadeIds?.length) params.SubGrupoUnidadeId = subGrupoUnidadeIds;
    if (estadoIds?.length) params.EstadoId = estadoIds;
    if (cidadeIds?.length) params.CidadeId = cidadeIds;
    if (fornecedorIds?.length) params.FornecedorId = fornecedorIds;

    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/setores`,
      params,
      paramsSerializer: paramsToSerialize => qs.stringify(paramsToSerialize, { arrayFormat: 'repeat' }),
      headers: {
        EmpresaId: companyId,
      },
    });
  },

  getUsers: ({
    companyId,
    unidadeId,
    fornecedores,
    search,
    usuarioId,
    tipoUsuario,
    grupoUnidadeId,
    subGrupoUnidadeId,
    estadoId,
    cidadeId,
    fornecedorId,
  }: GetUsersParams) => {
    const params: Record<string, number | number[] | string | undefined> = {};
    if (unidadeId?.length) params.UnidadeId = unidadeId;
    if (fornecedores?.length) params.Fornecedores = fornecedores;
    if (search) params.Search = search;
    if (usuarioId !== undefined) params.UsuarioId = usuarioId;
    if (tipoUsuario !== undefined) params.TipoUsuario = tipoUsuario;
    if (grupoUnidadeId?.length) params.GrupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId?.length) params.SubGrupoUnidadeId = subGrupoUnidadeId;
    if (estadoId?.length) params.EstadoId = estadoId;
    if (cidadeId?.length) params.CidadeId = cidadeId;
    if (fornecedorId?.length) params.FornecedorId = fornecedorId;
    return AxiosGlobalFilters({
      method: 'get',
      url: `/v1/usuarios`,
      params,
      paramsSerializer: p => qs.stringify(p, { arrayFormat: 'repeat' }),
      headers: {
        EmpresaId: companyId,
      },
    });
  },

  getMaintenanceUnits: ({
    companyId,
    unitId,
    usuarioTipo,
    grupoUnidadeIds,
    subGrupoUnidadeIds,
    estadoId,
    cidadeId,
    codigo,
    grupoUnidadeId,
    subGrupoUnidadeId,
    search,
    fornecedorId,
  }: GetMaintenanceUnitsParams) => {
    const params: Record<string, number | number[] | string> = {};

    if (usuarioTipo !== undefined) params.UsuarioTipo = usuarioTipo;
    if (grupoUnidadeIds && grupoUnidadeIds.length > 0) params.GrupoUnidadeIds = grupoUnidadeIds;
    if (subGrupoUnidadeIds && subGrupoUnidadeIds.length > 0) params.SubGrupoUnidadeIds = subGrupoUnidadeIds;
    if (estadoId !== undefined) params.EstadoId = estadoId;
    if (cidadeId !== undefined) params.CidadeId = cidadeId;
    if (codigo) params.Codigo = codigo;
    if (grupoUnidadeId !== undefined) params.grupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId !== undefined) params.subGrupoUnidadeId = subGrupoUnidadeId;
    if (search) params.Search = search;
    if (fornecedorId !== undefined) params.FornecedorId = fornecedorId;

    const headers: Record<string, number> = {
      EmpresaId: companyId,
    };
    if (unitId !== undefined) {
      headers.UnidadeId = unitId;
    }

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/unidades/ativas',
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      headers,
    });
  },

  getAreaGroups: ({
    companyId,
    unidadeId,
    search,
    PageIndex = 1,
    PageSize = 100,
    usuarioId,
    tipoUsuario,
    grupoUnidadeId,
    subGrupoUnidadeId,
    estadoId,
    cidadeId,
    fornecedorId,
  }: GetAreaGroupsParams) => {
    const params: Record<string, number | number[] | string | undefined> = {};
    if (unidadeId?.length) params.UnidadeId = unidadeId;
    if (search) params.Search = search;
    if (PageIndex !== undefined) params.PageIndex = PageIndex;
    if (PageSize !== undefined) params.PageSize = PageSize;
    if (usuarioId !== undefined) params.UsuarioId = usuarioId;
    if (tipoUsuario !== undefined) params.TipoUsuario = tipoUsuario;
    if (grupoUnidadeId?.length) params.GrupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId?.length) params.SubGrupoUnidadeId = subGrupoUnidadeId;
    if (estadoId?.length) params.EstadoId = estadoId;
    if (cidadeId?.length) params.CidadeId = cidadeId;
    if (fornecedorId?.length) params.FornecedorId = fornecedorId;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/gruposareas',
      params,
      paramsSerializer: paramsToSerialize => qs.stringify(paramsToSerialize, { arrayFormat: 'repeat' }),
      headers: {
        EmpresaId: companyId,
      },
    });
  },

  getAreaSubgroups: ({
    companyId,
    unidadeId,
    grupoAreaId,
    fornecedorId,
    search,
    PageIndex = 1,
    PageSize = 100,
    usuarioId,
    tipoUsuario,
    grupoUnidadeId,
    subGrupoUnidadeId,
    estadoId,
    cidadeId,
  }: GetAreaSubgroupsParams) => {
    const params: Record<string, number | number[] | string[] | string> = {
      PageIndex,
      PageSize,
    };
    if (unidadeId?.length) params.UnidadeId = unidadeId;
    if (grupoAreaId?.length) params.GrupoAreaId = grupoAreaId;
    if (fornecedorId?.length) params.FornecedorId = fornecedorId;
    if (search) params.Search = search;
    if (usuarioId !== undefined) params.UsuarioId = usuarioId;
    if (tipoUsuario !== undefined) params.TipoUsuario = tipoUsuario;
    if (grupoUnidadeId?.length) params.GrupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId?.length) params.SubGrupoUnidadeId = subGrupoUnidadeId;
    if (estadoId?.length) params.EstadoId = estadoId;
    if (cidadeId?.length) params.CidadeId = cidadeId;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/subgruposareas',
      params,
      paramsSerializer: paramsToSerialize => qs.stringify(paramsToSerialize, { arrayFormat: 'repeat' }),
      headers: {
        EmpresaId: companyId,
      },
    });
  },

  getAreas: ({
    companyId,
    siteId,
    fornecedoresIds,
    grupoAreaId,
    subGrupoAreaId,
    search,
    pageIndex,
    pageSize,
    areaId,
    planoAtividadesId,
  }: GetAreasParams) => {
    const params: Record<string, number | number[] | string | string[]> = {};

    if (siteId && siteId.length > 0) params.SiteId = siteId;
    if (fornecedoresIds && fornecedoresIds.length > 0) params.FornecedoresIds = fornecedoresIds;
    if (grupoAreaId && grupoAreaId.length > 0) params.GrupoAreaId = grupoAreaId;
    if (subGrupoAreaId && subGrupoAreaId.length > 0) params.SubGrupoAreaId = subGrupoAreaId;
    if (search) params.Search = search;
    if (pageIndex !== undefined) params.PageIndex = pageIndex;
    if (pageSize !== undefined) params.PageSize = pageSize;
    if (areaId && areaId.length > 0) params.AreaId = areaId;
    if (planoAtividadesId && planoAtividadesId.length > 0) params.PlanoAtividadesId = planoAtividadesId;

    const headers: Record<string, number> = {
      EmpresaId: companyId,
    };

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/areas',
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      headers,
    });
  },

  getEquipmentTypes: ({ companyId, unitId }: GetEquipmentTypesParams) => {
    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/tiposequipamentos',
      headers: {
        EmpresaId: companyId,
        UnidadeId: unitId,
      },
    });
  },

  getEquipments: ({
    companyId,
    siteId,
    fornecedoresIds,
    sistemaId,
    tipoEquipamentoId,
    grupoAreaId,
    subGrupoAreaId,
    equipamentoId,
    areaId,
    grupoEquipamentoId,
    planoAtividadeId,
    search,
    pageIndex,
    pageSize,
    fornecedorId,
  }: GetEquipmentsParams) => {
    const params: Record<string, number | number[] | string | string[]> = {};

    if (siteId && siteId.length > 0) params.SiteId = siteId;
    if (fornecedoresIds && fornecedoresIds.length > 0) params.FornecedoresIds = fornecedoresIds;
    if (sistemaId !== undefined) params.SistemaId = sistemaId;
    if (tipoEquipamentoId !== undefined) params.TipoEquipamentoId = tipoEquipamentoId;
    if (grupoAreaId && grupoAreaId.length > 0) params.GrupoAreaId = grupoAreaId;
    if (subGrupoAreaId && subGrupoAreaId.length > 0) params.SubGrupoAreaId = subGrupoAreaId;
    if (equipamentoId && equipamentoId.length > 0) params.EquipamentoId = equipamentoId;
    if (areaId && areaId.length > 0) params.AreaId = areaId;
    if (grupoEquipamentoId && grupoEquipamentoId.length > 0) params.GrupoEquipamentoId = grupoEquipamentoId;
    if (planoAtividadeId && planoAtividadeId.length > 0) params.PlanoAtividadeId = planoAtividadeId;
    if (search) params.Search = search;
    if (pageIndex !== undefined) params.PageIndex = pageIndex;
    if (pageSize !== undefined) params.PageSize = pageSize;
    if (fornecedorId !== undefined) params.FornecedorId = fornecedorId;

    const headers: Record<string, number> = {
      EmpresaId: companyId,
    };

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/equipamentos',
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      headers,
    });
  },

  getAgendaTasks: ({
    SelectedDate,
    Baixadas,
    DiasAdicionais,
    GrupoUnidadeId,
    SubGrupoUnidadeId,
    EstadoId,
    CidadeId,
    FornecedorId,
    EquipamentoId,
    TipoEquipamentoId,
    SistemaEmpresaId,
    SetorId,
    ExecutorId,
    GrupoAreaId,
    SubGrupoAreaId,
    AreaId,
    PlanoAtividadeId,
    AplicacaoPlanoAtividadeId,
    PageIndex,
    PageSize,
    EmpresaId,
    SiteId,
    TarefasIds,
  }: GetAgendaTasksParams) => {
    const params: Record<string, number | number[] | string | boolean> = {
      SelectedDate,
    };

    if (Baixadas !== undefined) params.Baixadas = Baixadas;
    if (DiasAdicionais !== undefined) params.DiasAdicionais = DiasAdicionais;
    if (GrupoUnidadeId !== undefined) params.GrupoUnidadeId = GrupoUnidadeId;
    if (SubGrupoUnidadeId !== undefined) params.SubGrupoUnidadeId = SubGrupoUnidadeId;
    if (EstadoId !== undefined) params.EstadoId = EstadoId;
    if (CidadeId !== undefined) params.CidadeId = CidadeId;
    if (FornecedorId !== undefined) params.FornecedorId = FornecedorId;
    if (EquipamentoId !== undefined) {
      if (Array.isArray(EquipamentoId) && EquipamentoId.length > 0) {
        params.EquipamentoId = EquipamentoId;
      } else if (!Array.isArray(EquipamentoId)) {
        params.EquipamentoId = EquipamentoId;
      }
    }
    if (TipoEquipamentoId !== undefined) {
      if (Array.isArray(TipoEquipamentoId) && TipoEquipamentoId.length > 0) {
        params.TipoEquipamentoId = TipoEquipamentoId;
      } else if (!Array.isArray(TipoEquipamentoId)) {
        params.TipoEquipamentoId = TipoEquipamentoId;
      }
    }
    if (SistemaEmpresaId !== undefined) params.SistemaEmpresaId = SistemaEmpresaId;
    if (SetorId !== undefined) {
      if (Array.isArray(SetorId) && SetorId.length > 0) {
        params.SetorId = SetorId;
      } else if (!Array.isArray(SetorId)) {
        params.SetorId = SetorId;
      }
    }
    if (ExecutorId !== undefined) {
      if (Array.isArray(ExecutorId) && ExecutorId.length > 0) {
        params.ExecutorId = ExecutorId;
      } else if (!Array.isArray(ExecutorId)) {
        params.ExecutorId = ExecutorId;
      }
    }
    if (GrupoAreaId !== undefined) {
      if (Array.isArray(GrupoAreaId) && GrupoAreaId.length > 0) {
        params.GrupoAreaId = GrupoAreaId;
      } else if (!Array.isArray(GrupoAreaId)) {
        params.GrupoAreaId = GrupoAreaId;
      }
    }
    if (SubGrupoAreaId !== undefined) {
      if (Array.isArray(SubGrupoAreaId) && SubGrupoAreaId.length > 0) {
        params.SubGrupoAreaId = SubGrupoAreaId;
      } else if (!Array.isArray(SubGrupoAreaId)) {
        params.SubGrupoAreaId = SubGrupoAreaId;
      }
    }
    if (AreaId !== undefined) {
      if (Array.isArray(AreaId) && AreaId.length > 0) {
        params.AreaId = AreaId;
      } else if (!Array.isArray(AreaId)) {
        params.AreaId = AreaId;
      }
    }
    if (PlanoAtividadeId !== undefined) {
      if (Array.isArray(PlanoAtividadeId) && PlanoAtividadeId.length > 0) {
        params.PlanoAtividadeId = PlanoAtividadeId;
      } else if (!Array.isArray(PlanoAtividadeId)) {
        params.PlanoAtividadeId = PlanoAtividadeId;
      }
    }
    if (AplicacaoPlanoAtividadeId !== undefined) params.AplicacaoPlanoAtividadeId = AplicacaoPlanoAtividadeId;
    if (PageIndex !== undefined) params.PageIndex = PageIndex;
    if (PageSize !== undefined) params.PageSize = PageSize;
    if (EmpresaId !== undefined) params.EmpresaId = EmpresaId;
    if (SiteId && SiteId.length > 0) params.SiteId = SiteId;
    if (TarefasIds && TarefasIds.length > 0) params.TarefasIds = TarefasIds;

    const headers: Record<string, number> = {};
    if (EmpresaId !== undefined) {
      headers.EmpresaId = EmpresaId;
    }

    return AxiosReportLas({
      method: 'get',
      url: '/v1/Agenda/planoAplicacao',
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      headers,
    });
  },

  getAgendaTarefas: ({
    aplicacaoPlanoAtividadeId,
    data,
    status,
    usuarioId,
    empresaId,
    unidadeId,
  }: GetAgendaTarefasParams) => {
    const params: Record<string, number | string> = {
      AplicacaoPlanoAtividadeId: aplicacaoPlanoAtividadeId,
      Data: data,
      Status: status,
    };

    if (usuarioId !== undefined) params.UsuarioId = usuarioId;
    if (empresaId !== undefined) params.EmpresaId = empresaId;

    const headers: Record<string, number> = {};
    if (unidadeId !== undefined) headers.UnidadeId = unidadeId;
    if (empresaId !== undefined) headers.EmpresaId = empresaId;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/agenda/tarefas',
      params,
      headers,
    });
  },

  deleteAgendaTarefas: ({ tarefasIds, usuarioId, empresaId, unidadeId }: DeleteAgendaTarefasParams) => {
    const headers: Record<string, number> = { EmpresaId: empresaId };
    if (unidadeId !== undefined) headers.UnidadeId = unidadeId;
    return AxiosGlobalFilters({
      method: 'delete',
      url: '/v1/atividades/tarefas',
      data: { tarefasIds, usuarioId, empresaId },
      headers,
    });
  },

  alterarAgendamento: ({ usuarioId, empresaId, unidadeId, itens }: AlterarAgendamentoParams) => {
    const headers: Record<string, number> = { EmpresaId: empresaId };
    if (unidadeId !== undefined) headers.UnidadeId = unidadeId;
    return AxiosGlobalFilters({
      method: 'post',
      url: '/v1/atividades/tarefas/alterarAgendamento',
      data: { usuarioId, empresaId, itens },
      headers,
    });
  },

  alterarAgendamentoAplicacao: ({ usuarioId, empresaId, unidadeId, itens }: AlterarAgendamentoAplicacaoParams) => {
    const headers: Record<string, number> = { EmpresaId: empresaId };
    if (unidadeId !== undefined) headers.UnidadeId = unidadeId;
    return AxiosGlobalFilters({
      method: 'post',
      url: '/v1/atividades/aplicacoes/alterarAgendamento',
      data: { usuarioId, empresaId, itens },
      headers,
    });
  },

  restaurarTarefas: ({
    tarefasIds,
    usuarioId,
    empresaId,
    unidadeId,
    motivoReprovacao,
    excluirFotosAssinaturas,
  }: RestaurarTarefasParams) => {
    const headers: Record<string, number> = { EmpresaId: empresaId };
    if (unidadeId !== undefined) headers.UnidadeId = unidadeId;
    return AxiosGlobalFilters({
      method: 'post',
      url: '/v1/atividades/tarefas/restaurar',
      data: { tarefasIds, motivoReprovacao, excluirFotosAssinaturas, usuarioId, empresaId },
      headers,
    });
  },

  reagendarTarefas: async (params: ReagendarTarefasParams) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Agenda/reagendarTarefas',
      data: {
        usuarioId: params.usuarioId,
        tarefasIds: params.tarefasIds,
        novaDataHora: params.novaDataHora,
      },
    });
  },
};

export { AgendaService };
